// File: config.appbarmenu.ts
// Author: James L Seebach
// Date: 5/15/2017
// Desc: Configuration file for app bar menu item list.
// Other Contributors:

export const appBarMenuItems = [
        { name: ' User Profile', action: 'openProfileDialog', icon: 'fa fa-user-o' },
        { name: ' MESC Help', action: 'helpLink', icon: 'fa fa-question-circle-o' },
        { name: ' Logout', action: 'logOut', icon: 'fa fa-sign-out' }
];

